exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-container[data-v-7cd35818] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.buttons[data-v-7cd35818] {\n  display: flex;\n  justify-content: right;\n  text-align: right;\n  margin-top: 30px;\n}\n", ""]);

// exports
